'use strict'

/**
 * トリガーサイズCSS
 * src/scss/foundation/mixnins/_media-queries.scss
 */

export const MQ_TRIGGER = {
  // Device Size for Mobile ~4inch (iPhone 5)
  XS: 350,
  // Device Size for Mobile 5inch~ (iPhone 6~, iPhone6 Plus~, Galaxy 7...)
  S: 450,
  // Device Size for Phablet (Galaxy Note, Xperia ZL)
  XT: 600,
  // Device Size for Tablet (iPad Mini, iPad)
  T: 940,
  // Device Size for Mini computer
  M: 1180,
  // Device Size for Computer
  L: 1350,
  // Device Size for Large Desktop
  XL: 1700
}

// ウィンドウの幅を取得する
export function getWindowWidth() {
  return (document.body.clientWidth || window.innerWidth)
}

export function MQ_MIN(trigger) {
  const width = getWindowWidth()
  if (trigger === 'S') {
    return (width > MQ_TRIGGER.XS)
  } else if (trigger === 'XT') {
    return (width > MQ_TRIGGER.S)
  } else if (trigger === 'T') {
    return (width > MQ_TRIGGER.XT)
  } else if (trigger === 'M') {
    return (width > MQ_TRIGGER.T)
  } else if (trigger === 'L') {
    return (width > MQ_TRIGGER.M)
  } else if (trigger === 'XL') {
    return (width > MQ_TRIGGER.L)
  }
}

export function MQ_MAX(trigger) {
  const width = getWindowWidth()
  if (trigger === 'XS') {
    return (width <= MQ_TRIGGER.XS)
  } else if (trigger === 'S') {
    return (width <= MQ_TRIGGER.S)
  } else if (trigger === 'XT') {
    return (width <= MQ_TRIGGER.XT)
  } else if (trigger === 'T') {
    return (width <= MQ_TRIGGER.T)
  } else if (trigger === 'M') {
    return (width <= MQ_TRIGGER.M)
  } else if (trigger === 'L') {
    return (width <= MQ_TRIGGER.L)
  } else if (trigger === 'XL') {
    return (width <= MQ_TRIGGER.XL)
  }
}

export function MQ_ONLY(trigger) {
  const width = getWindowWidth()
  if (trigger === 'XS') {
    return (width > 0 && width <= MQ_TRIGGER.XS)
  } else if (trigger === 'S') {
    return (width > MQ_TRIGGER.XS && width <= MQ_TRIGGER.S)
  } else if (trigger === 'XT') {
    return (width > MQ_TRIGGER.S && width <= MQ_TRIGGER.XT)
  } else if (trigger === 'T') {
    return (width > MQ_TRIGGER.XT && width <= MQ_TRIGGER.T)
  } else if (trigger === 'M') {
    return (width > MQ_TRIGGER.T && width <= MQ_TRIGGER.M)
  } else if (trigger === 'L') {
    return (width > MQ_TRIGGER.M && width <= MQ_TRIGGER.L)
  } else if (trigger === 'XL') {
    return (width > MQ_TRIGGER.L && width <= MQ_TRIGGER.XL)
  }
}

export function MQ_BETWEEN(triggerMin, triggerMax) {
  const width = getWindowWidth()

  let max = 3000
  if (triggerMax === 'S') {
    max = MQ_TRIGGER.S
  } else if (triggerMax === 'XT') {
    max = MQ_TRIGGER.XT
  } else if (triggerMax === 'T') {
    max = MQ_TRIGGER.T
  } else if (triggerMax === 'M') {
    max = MQ_TRIGGER.M
  } else if (triggerMax === 'L') {
    max = MQ_TRIGGER.L
  } else if (triggerMax === 'XL') {
    max = MQ_TRIGGER.XL
  }

  if (triggerMin === 'XS') {
    return (width > 0 && width <= max)
  } else if (triggerMin === 'S') {
    return (width > MQ_TRIGGER.XS && width <= max)
  } else if (triggerMin === 'XT') {
    return (width > MQ_TRIGGER.S && width <= max)
  } else if (triggerMin === 'T') {
    return (width > MQ_TRIGGER.XT && width <= max)
  } else if (triggerMin === 'M') {
    return (width > MQ_TRIGGER.T && width <= max)
  } else if (triggerMin === 'L') {
    return (width > MQ_TRIGGER.M && width <= max)
  } else if (triggerMin === 'XL') {
    return (width > MQ_TRIGGER.L && width <= max)
  }
}
